(function(angular) {
  'use strict';

  var app = angular.module('asSecureCommerce');

  app.service('seApi', [
    '$http',
    '$q',
    function($http, $q) {


      this.save = function(target, data) {
        var url = '/se/' + target;

        return $q(function(resolve, reject) {
          $http.post(url, data).then(
            // success
            function(res) {
              if (res.data.status === 'success') {
                resolve(res.data);
              } else {
                reject(res.data);
              }
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };


    },
  ]);
})(window.angular);
